var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("mds-combo-box", {
    attrs: {
      label: _vm.translate("frequency.modal.weekly.label"),
      "data-set": _vm.dataSet,
      "selected-items": _vm.selectedFixedDay,
    },
    on: { input: _vm.emitWeeklyFrequency },
    model: {
      value: _vm.selectedFixedDay,
      callback: function ($$v) {
        _vm.selectedFixedDay = $$v
      },
      expression: "selectedFixedDay",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }